import * as React from 'react';
import { withStyles } from '@material-ui/core/styles';
const styles = {
  link: {
    textDecoration: 'none',
    color: 'black',
    display: 'inline-block',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    width: '100%',
    '&:hover': {
      textDecoration: 'underline'
    }
  },
  label: {
    cursor: 'pointer'
  }
};
const TextField = props => {
  const renderLabel = () => {
    const custom = props.custom,
      rowData = props.rowData,
      colData = props.colData;
    const content = typeof props.children === 'string' ? props.children : '';
    let style = custom && typeof custom.style === 'function' ? custom.style(rowData, colData) : {};
    return /*#__PURE__*/React.createElement("label", {
      className: "".concat(props.classes.label),
      title: content,
      "data-test": props.testClass,
      style: style
    }, content);
  };
  const clickHandler = e => {
    if (props.onClick && typeof props.onClick === 'function') {
      e.stopPropagation();
      props.onClick(props.appState, 0, props.rowData, props.tab, props.initialProps);
    }
  };
  if (props.onClick) {
    return /*#__PURE__*/React.createElement("div", {
      onClick: e => clickHandler(e)
    }, renderLabel());
  } else if (props.link) {
    return /*#__PURE__*/React.createElement("a", {
      className: "".concat(props.classes.link, " ").concat(props.testClass || ''),
      href: props.link,
      "data-testid": "textFieldLink"
    }, renderLabel());
  } else {
    return renderLabel();
  }
};
export default withStyles(styles)(TextField);